import React from 'react'
import Navigation from './routes'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css'

function App() {
  return (
    <div>
      <Navigation/>
    </div>
  )
}

export default App